$(function() {
	
	var mappa = new window.FipeMap();
	mappa.init($);

});


// WEBPACK FOOTER //
// ./scripts/autoload/mappa.js